import { ENABLE_LEARNING_CENTER } from "config/featureFlags";

export function canViewLearningCenter(user) {
  return Boolean(ENABLE_LEARNING_CENTER || user?.settings?.role === "admin");
}
